import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect from "react-select";

import { organizationsSelector } from "../reducers";
import { reactSelectSearchSettings, zIndexFix } from "../common/reactselect";
import { getAllOrganizations, selectOrganization } from "../actions/organization/organizationsgetall";

const keySelectedOrganization = "selectedOrganization";


export function SelectOrganization() {

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [selectOrganizationOptions, setSelectOrganizationOptions] = useState([]);

  const organizations = useSelector(organizationsSelector);
  const setOrganization = idx => dispatch(selectOrganization( organizations[idx] ));
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    dispatch(getAllOrganizations());
  }, []);

  useEffect(() => {
    if (organizations) {
      setSelectOrganizationOptions(organizations.map((organization, idx) => ({
        value: idx,
        label: `${organization.organizationName} (${organization.businessIdentifier})`,
        id: organization.id,
        businessIdentifier: organization.businessIdentifier,
      })));
    }
  }, [organizations]);

  useEffect(() => {
    if (selectOrganizationOptions.length) {
      const storedOrganizationIdx = localStorage.getItem(keySelectedOrganization);

      if (storedOrganizationIdx != null && selectOrganizationOptions[storedOrganizationIdx]) {
        setSelectedOption(selectOrganizationOptions[storedOrganizationIdx]);
        setOrganization(storedOrganizationIdx);
      } else {
        setSelectedOption(selectOrganizationOptions[0]);
        setOrganization(0);
      }
    }

  }, [selectOrganizationOptions]);

  const selectOption = option => {
    setSelectedOption(option);
    setOrganization(option.value);
    localStorage.setItem(keySelectedOrganization, option.value);
  };

  return <ReactSelect
    styles={zIndexFix}
    onChange={selectOption}
    options={selectOrganizationOptions}
    value={selectedOption}
    {...reactSelectSearchSettings(t)}
  />;
}
